export default function ChapterDetail6(props) {
  document.title = props.text + " | Arisu";
  
	return (
    <>
      <p className="indent-8">
        For a minute or two she stood looking at the house, and wondering what to do
        next, when suddenly a footman in livery came running out of the wood—(she
        considered him to be a footman because he was in livery: otherwise, judging by
        his face only, she would have called him a fish)—and rapped loudly at the
        door with his knuckles. It was opened by another footman in livery, with a
        round face, and large eyes like a frog; and both footmen, Alice noticed, had
        powdered hair that curled all over their heads. She felt very curious to know
        what it was all about, and crept a little way out of the wood to listen.
      </p>
      <p className="indent-8">
        The Fish-Footman began by producing from under his arm a great letter, nearly
        as large as himself, and this he handed over to the other, saying, in a solemn
        tone, “For the Duchess. An invitation from the Queen to play
        croquet.” The Frog-Footman repeated, in the same solemn tone, only
        changing the order of the words a little, “From the Queen. An invitation
        for the Duchess to play croquet.”
      </p>
      <p className="indent-8">
        Then they both bowed low, and their curls got entangled together.
      </p>
      <p className="indent-8">
        Alice laughed so much at this, that she had to run back into the wood for fear
        of their hearing her; and when she next peeped out the Fish-Footman was gone,
        and the other was sitting on the ground near the door, staring stupidly up into
        the sky.
      </p>
      <p className="indent-8">
        Alice went timidly up to the door, and knocked.
      </p>
      <p className="indent-8">
        “There’s no sort of use in knocking,” said the Footman,
        “and that for two reasons. First, because I’m on the same side of
        the door as you are; secondly, because they’re making such a noise
        inside, no one could possibly hear you.” And certainly there <i>was</i> a
        most extraordinary noise going on within—a constant howling and sneezing,
        and every now and then a great crash, as if a dish or kettle had been broken to
        pieces.
      </p>
      <p className="indent-8">
        “Please, then,” said Alice, “how am I to get in?”
      </p>
      <p className="indent-8">
        “There might be some sense in your knocking,” the Footman went on
        without attending to her, “if we had the door between us. For instance,
        if you were <i>inside</i>, you might knock, and I could let you out, you
        know.” He was looking up into the sky all the time he was speaking, and
        this Alice thought decidedly uncivil. “But perhaps he can’t help
        it,” she said to herself; “his eyes are so <i>very</i> nearly at
        the top of his head. But at any rate he might answer questions.—How am I
        to get in?” she repeated, aloud.
      </p>
      <p className="indent-8">
        “I shall sit here,” the Footman remarked, “till
        tomorrow—”
      </p>
      <p className="indent-8">
        At this moment the door of the house opened, and a large plate came skimming
        out, straight at the Footman’s head: it just grazed his nose, and broke
        to pieces against one of the trees behind him.
      </p>
      <p className="indent-8">
        “—or next day, maybe,” the Footman continued in the same
        tone, exactly as if nothing had happened.
      </p>
      <p className="indent-8">
        “How am I to get in?” asked Alice again, in a louder tone.
      </p>
      <p className="indent-8">
        “<i>Are</i> you to get in at all?” said the Footman.
        “That’s the first question, you know.”
      </p>
      <p className="indent-8">
        It was, no doubt: only Alice did not like to be told so. “It’s
        really dreadful,” she muttered to herself, “the way all the
        creatures argue. It’s enough to drive one crazy!”
      </p>
      <p className="indent-8">
        The Footman seemed to think this a good opportunity for repeating his remark,
        with variations. “I shall sit here,” he said, “on and off,
        for days and days.”
      </p>
      <p className="indent-8">
        “But what am <i>I</i> to do?” said Alice.
      </p>
      <p className="indent-8">
        “Anything you like,” said the Footman, and began whistling.
      </p>
      <p className="indent-8">
        “Oh, there’s no use in talking to him,” said Alice
        desperately: “he’s perfectly idiotic!” And she opened the
        door and went in.
      </p>
      <p className="indent-8">
        The door led right into a large kitchen, which was full of smoke from one end
        to the other: the Duchess was sitting on a three-legged stool in the middle,
        nursing a baby; the cook was leaning over the fire, stirring a large cauldron
        which seemed to be full of soup.
      </p>
      <p className="indent-8">
        “There’s certainly too much pepper in that soup!” Alice said
        to herself, as well as she could for sneezing.
      </p>
      <p className="indent-8">
        There was certainly too much of it in the air. Even the Duchess sneezed
        occasionally; and as for the baby, it was sneezing and howling alternately
        without a moment’s pause. The only things in the kitchen that did not
        sneeze, were the cook, and a large cat which was sitting on the hearth and
        grinning from ear to ear.
      </p>
      <p className="indent-8">
        “Please would you tell me,” said Alice, a little timidly, for she
        was not quite sure whether it was good manners for her to speak first,
        “why your cat grins like that?”
      </p>
      <p className="indent-8">
        “It’s a Cheshire cat,” said the Duchess, “and
        that’s why. Pig!”
      </p>
      <p className="indent-8">
        She said the last word with such sudden violence that Alice quite jumped; but
        she saw in another moment that it was addressed to the baby, and not to her, so
        she took courage, and went on again:—
      </p>
      <p className="indent-8">
        “I didn’t know that Cheshire cats always grinned; in fact, I
        didn’t know that cats <i>could</i> grin.”
      </p>
      <p className="indent-8">
        “They all can,” said the Duchess; “and most of ’em
        do.”
      </p>
      <p className="indent-8">
        “I don’t know of any that do,” Alice said very politely,
        feeling quite pleased to have got into a conversation.
      </p>
      <p className="indent-8">
        “You don’t know much,” said the Duchess; “and
        that’s a fact.”
      </p>
      <p className="indent-8">
        Alice did not at all like the tone of this remark, and thought it would be as
        well to introduce some other subject of conversation. While she was trying to
        fix on one, the cook took the cauldron of soup off the fire, and at once set to
        work throwing everything within her reach at the Duchess and the baby—the
        fire-irons came first; then followed a shower of saucepans, plates, and dishes.
        The Duchess took no notice of them even when they hit her; and the baby was
        howling so much already, that it was quite impossible to say whether the blows
        hurt it or not.
      </p>
      <p className="indent-8">
        “Oh, <i>please</i> mind what you’re doing!” cried Alice,
        jumping up and down in an agony of terror. “Oh, there goes his
        <i>precious</i> nose!” as an unusually large saucepan flew close by it,
        and very nearly carried it off.
      </p>
      <p className="indent-8">
        “If everybody minded their own business,” the Duchess said in a
        hoarse growl, “the world would go round a deal faster than it
        does.”
      </p>
      <p className="indent-8">
        “Which would <i>not</i> be an advantage,” said Alice, who felt very
        glad to get an opportunity of showing off a little of her knowledge.
        “Just think of what work it would make with the day and night! You see
        the earth takes twenty-four hours to turn round on its axis—”
      </p>
      <p className="indent-8">
        “Talking of axes,” said the Duchess, “chop off her
        head!”
      </p>
      <p className="indent-8">
        Alice glanced rather anxiously at the cook, to see if she meant to take the
        hint; but the cook was busily stirring the soup, and seemed not to be
        listening, so she went on again: “Twenty-four hours, I <i>think</i>; or
        is it twelve? I—”
      </p>
      <p className="indent-8">
        “Oh, don’t bother <i>me</i>,” said the Duchess; “I
        never could abide figures!” And with that she began nursing her child
        again, singing a sort of lullaby to it as she did so, and giving it a violent
        shake at the end of every line:
      </p>
      <div className="grid justify-center">
        <p className="mt-2">“Speak roughly to your little boy,</p>
        <p className="indent-8">And beat him when he sneezes:</p>
        <p className="mx-2">He only does it to annoy,</p>
        <p className="indent-8 mb-2">Because he knows it teases.”</p>
        <p className="text-center">CHORUS.</p>
        <p className="text-center">(In which the cook and the baby joined):</p>
        <p className="mb-2">“Wow! wow! wow!”</p>
      </div>
      <p className="indent-8">
        While the Duchess sang the second verse of the song, she kept tossing the baby
        violently up and down, and the poor little thing howled so, that Alice could
        hardly hear the words:—
      </p>
      <div className="grid justify-center">
        <p className="mt-2">“I speak severely to my boy,</p>
        <p className="indent-8">I beat him when he sneezes;</p>
        <p className="mx-2">For he can thoroughly enjoy</p>
        <p className="indent-8 mb-2">The pepper when he pleases!”</p>
        <p className="text-center">CHORUS.</p>
        <p className="mb-2">“Wow! wow! wow!”</p>
      </div>
      <p className="indent-8">
        “Here! you may nurse it a bit, if you like!” the Duchess said to
        Alice, flinging the baby at her as she spoke. “I must go and get ready to
        play croquet with the Queen,” and she hurried out of the room. The cook
        threw a frying-pan after her as she went out, but it just missed her.
      </p>
      <p className="indent-8">
        Alice caught the baby with some difficulty, as it was a queer-shaped little
        creature, and held out its arms and legs in all directions, “just like a
        star-fish,” thought Alice. The poor little thing was snorting like a
        steam-engine when she caught it, and kept doubling itself up and straightening
        itself out again, so that altogether, for the first minute or two, it was as
        much as she could do to hold it.
      </p>
      <p className="indent-8">
        As soon as she had made out the proper way of nursing it, (which was to twist
        it up into a sort of knot, and then keep tight hold of its right ear and left
        foot, so as to prevent its undoing itself,) she carried it out into the open
        air. “If I don’t take this child away with me,” thought
        Alice, “they’re sure to kill it in a day or two: wouldn’t it
        be murder to leave it behind?” She said the last words out loud, and the
        little thing grunted in reply (it had left off sneezing by this time).
        “Don’t grunt,” said Alice; “that’s not at all a
        proper way of expressing yourself.”
      </p>
      <p className="indent-8">
        The baby grunted again, and Alice looked very anxiously into its face to see
        what was the matter with it. There could be no doubt that it had a <i>very</i>
        turn-up nose, much more like a snout than a real nose; also its eyes were
        getting extremely small for a baby: altogether Alice did not like the look of
        the thing at all. “But perhaps it was only sobbing,” she thought,
        and looked into its eyes again, to see if there were any tears.
      </p>
      <p className="indent-8">
        No, there were no tears. “If you’re going to turn into a pig, my
        dear,” said Alice, seriously, “I’ll have nothing more to do
        with you. Mind now!” The poor little thing sobbed again (or grunted, it
        was impossible to say which), and they went on for some while in silence.
      </p>
      <p className="indent-8">
        Alice was just beginning to think to herself, “Now, what am I to do with
        this creature when I get it home?” when it grunted again, so violently,
        that she looked down into its face in some alarm. This time there could be
        <i>no</i> mistake about it: it was neither more nor less than a pig, and she
        felt that it would be quite absurd for her to carry it further.
      </p>
      <p className="indent-8">
        So she set the little creature down, and felt quite relieved to see it trot
        away quietly into the wood. “If it had grown up,” she said to
        herself, “it would have made a dreadfully ugly child: but it makes rather
        a handsome pig, I think.” And she began thinking over other children she
        knew, who might do very well as pigs, and was just saying to herself, “if
        one only knew the right way to change them—” when she was a little
        startled by seeing the Cheshire Cat sitting on a bough of a tree a few yards
        off.
      </p>
      <p className="indent-8">
        The Cat only grinned when it saw Alice. It looked good-natured, she thought:
        still it had <i>very</i> long claws and a great many teeth, so she felt that it
        ought to be treated with respect.
      </p>
      <p className="indent-8">
        “Cheshire Puss,” she began, rather timidly, as she did not at all
        know whether it would like the name: however, it only grinned a little wider.
        “Come, it’s pleased so far,” thought Alice, and she went on.
        “Would you tell me, please, which way I ought to go from here?”
      </p>
      <p className="indent-8">
        “That depends a good deal on where you want to get to,” said the
        Cat.
      </p>
      <p className="indent-8">
        “I don’t much care where—” said Alice.
      </p>
      <p className="indent-8">
        “Then it doesn’t matter which way you go,” said the Cat.
      </p>
      <p className="indent-8">
        “—so long as I get <i>somewhere</i>,” Alice added as an
        explanation.
      </p>
      <p className="indent-8">
        “Oh, you’re sure to do that,” said the Cat, “if you
        only walk long enough.”
      </p>
      <p className="indent-8">
        Alice felt that this could not be denied, so she tried another question.
        “What sort of people live about here?”
      </p>
      <p className="indent-8">
        “In <i>that</i> direction,” the Cat said, waving its right paw
        round, “lives a Hatter: and in <i>that</i> direction,” waving the
        other paw, “lives a March Hare. Visit either you like: they’re both
        mad.”
      </p>
      <p className="indent-8">
        “But I don’t want to go among mad people,” Alice remarked.
      </p>
      <p className="indent-8">
        “Oh, you can’t help that,” said the Cat: “we’re
        all mad here. I’m mad. You’re mad.”
      </p>
      <p className="indent-8">
        “How do you know I’m mad?” said Alice.
      </p>
      <p className="indent-8">
        “You must be,” said the Cat, “or you wouldn’t have come
        here.”
      </p>
      <p className="indent-8">
        Alice didn’t think that proved it at all; however, she went on “And
        how do you know that you’re mad?”
      </p>
      <p className="indent-8">
        “To begin with,” said the Cat, “a dog’s not mad. You
        grant that?”
      </p>
      <p className="indent-8">
        “I suppose so,” said Alice.
      </p>
      <p className="indent-8">
        “Well, then,” the Cat went on, “you see, a dog growls when
        it’s angry, and wags its tail when it’s pleased. Now <i>I</i> growl
        when I’m pleased, and wag my tail when I’m angry. Therefore
        I’m mad.”
      </p>
      <p className="indent-8">
        “<i>I</i> call it purring, not growling,” said Alice.
      </p>
      <p className="indent-8">
        “Call it what you like,” said the Cat. “Do you play croquet
        with the Queen to-day?”
      </p>
      <p className="indent-8">
        “I should like it very much,” said Alice, “but I
        haven’t been invited yet.”
      </p>
      <p className="indent-8">
        “You’ll see me there,” said the Cat, and vanished.
      </p>
      <p className="indent-8">
        Alice was not much surprised at this, she was getting so used to queer things
        happening. While she was looking at the place where it had been, it suddenly
        appeared again.
      </p>
      <p className="indent-8">
        “By-the-bye, what became of the baby?” said the Cat.
        “I’d nearly forgotten to ask.”
      </p>
      <p className="indent-8">
        “It turned into a pig,” Alice quietly said, just as if it had come
        back in a natural way.
      </p>
      <p className="indent-8">
        “I thought it would,” said the Cat, and vanished again.
      </p>
      <p className="indent-8">
        Alice waited a little, half expecting to see it again, but it did not appear,
        and after a minute or two she walked on in the direction in which the March
        Hare was said to live. “I’ve seen hatters before,” she said
        to herself; “the March Hare will be much the most interesting, and
        perhaps as this is May it won’t be raving mad—at least not so mad
        as it was in March.” As she said this, she looked up, and there was the
        Cat again, sitting on a branch of a tree.
      </p>
      <p className="indent-8">
        “Did you say pig, or fig?” said the Cat.
      </p>
      <p className="indent-8">
        “I said pig,” replied Alice; “and I wish you wouldn’t
        keep appearing and vanishing so suddenly: you make one quite giddy.”
      </p>
      <p className="indent-8">
        “All right,” said the Cat; and this time it vanished quite slowly,
        beginning with the end of the tail, and ending with the grin, which remained
        some time after the rest of it had gone.
      </p>
      <p className="indent-8">
        “Well! I’ve often seen a cat without a grin,” thought Alice;
        “but a grin without a cat! It’s the most curious thing I ever saw
        in my life!”
      </p>
      <p className="indent-8">
        She had not gone much farther before she came in sight of the house of the
        March Hare: she thought it must be the right house, because the chimneys were
        shaped like ears and the roof was thatched with fur. It was so large a house,
        that she did not like to go nearer till she had nibbled some more of the
        lefthand bit of mushroom, and raised herself to about two feet high: even then
        she walked up towards it rather timidly, saying to herself “Suppose it
        should be raving mad after all! I almost wish I’d gone to see the Hatter
        instead!”
      </p>
    </>
  )
}